/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Blog methods
 * -----------------------------------------------------------------------------
 *
 * @namespace blogMethods
 */

// date picker component
// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';

const blogMethods = {
  components: {
    // flatPickr,
  },

  methods: {
    _initBlog() {

      if (app.currentTemplate !== 'blog-article-topics') {
        return;
      }

      const $blog_apps_list = $('.blog-apps-list');
      const $blog_list_seond = $blog_apps_list.find('.blog-apps-list-second');
      const $blog_list_first = $blog_apps_list.find('.blog-apps-list-first');
      const $view_more_apps = $blog_apps_list.find('.view-more-apps');
      const blog_apps_list_len = $blog_list_seond.find('li').length;
      if (blog_apps_list_len > 0) {
        $view_more_apps.show();
      } else {
        $view_more_apps.hide();
      }
      $blog_list_seond.hide();
      $('body').on('click', '.blog-apps-list .view-more-apps', function(e) {
        $blog_list_seond.toggleClass('active').slideToggle();
        if ($blog_list_seond.hasClass('active')) {
          $blog_list_first.find('li').css('border', '0');
          $(this).find('u').text('Hide');
        } else {
          $blog_list_first.find('li').removeAttr('style');
          $(this).find('u').text('View more');
        }
      });
      $(document).on('click', '.blog-apps', function(e) {
        const data_tag = $(this).attr('data-tag');
        const data_url = $(this).attr('data-url');

        let url = window.location.href;
        const page = url.split('?');
        if (page.length > 1) {
          url = page[0];
        }
        const url_arr = url.split('/tagged');

        let tag_flag = false;
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        let $el = '';
        let newURL;

        // If alraedy one or more tags are present in the URL
        if (url_arr.length > 1) {
          const tag_arr = url.split('+');

          // If more than one tag is present in the URL
          if (tag_arr.length > 1) {
            let app_tag = url_arr[1].replace('/', '').split('+');
            // Checking If current clicked tag's parent is from categories
            if ($(this).parents('.categories-articles').length > 0) {
              $el = $(this).parents('.categories-articles');
            } else {
              // Checking If current clicked tag's parent is from app list
              // eslint-disable-next-line no-lonely-if
              if ($(this).parents('.blog-apps-list').length > 0) {
                $el = $(this).parents('.blog-apps-list');
              }
            }
            $el.find('li').each(function(index, item) {
              const tag = $(this).find('a').attr('data-tag');
                // Removing the tag of same type(category/app list) according which tag is clicked currently
              app_tag = jQuery.grep(app_tag, (value) => {
                return value !== tag;
              });
            });
            newURL = `${url_arr[0]}/tagged/${data_tag}+${app_tag}`;
            app._getAjaxBlogData(url, newURL);
          } else { // If only one tag is present in the URL
            tag_flag = false;
            $('.blog-apps-list li').each(function(index, item) {
              const tag = $(this).find('a').attr('data-tag');
              if (url_arr[1].replace('/', '') === tag) {
                tag_flag = true;
                return false;
              }
            });
            // If one tag present in URL is from app list
            if (tag_flag) {
              let tag_category = false;
              $('.categories-articles li').each(function(index, item) {
                const tag = $(this).find('a').attr('data-tag');
                if (data_tag === tag) {
                  tag_category = true;
                  return false;
                }
              });
              // If clicked tag is category
              if (tag_category) {
                newURL = `${url}+${data_tag}`;
              } else { // If clicked tag is app list
                newURL = `${url_arr[0]}/tagged/${data_tag}`;
              }
              app._getAjaxBlogData(url, newURL);
            } else { // If one tag present in URL is not from app list
              tag_flag = false;
              // eslint-disable-next-line shopify/jquery-dollar-sign-reference
              $el = '';
              // Checking If current clicked tag's parent is from categories
              if ($(this).parents('.categories-articles').length > 0) {
                $el = $(this).parents('.categories-articles');
              } else { // Checking If current clicked tag's parent is not from categories
                // Checking If current clicked tag's parent is from app list
                // eslint-disable-next-line no-lonely-if
                if ($(this).parents('.blog-apps-list').length > 0) {
                  $el = $(this).parents('.blog-apps-list');
                }
              }
              $el.find('li').each(function(index, item) {
                const tag = $(this).find('a').attr('data-tag');
                if (tag === url_arr[1].replace('/', '')) {
                  tag_flag = true;
                  return false;
                }

              });
              if (tag_flag) {
                newURL = `${url_arr[0]}/tagged/${data_tag}`;
                window.location.href = newURL;
              } else {
                newURL = `${url}+${data_tag}`;
                app._getAjaxBlogData(url, newURL);
              }
            }
          }
        } else { // If already no tag is present in the URL
          tag_flag = false;
          // Checking If current clicked tag's parent is from categories
          if ($(this).parents('.categories-articles').length > 0) {
            tag_flag = false;
          } else { // Checking If current clicked tag's parent is from app list
            // eslint-disable-next-line no-lonely-if
            if ($(this).parents('.blog-apps-list').length > 0) {
              tag_flag = true;
            }
          }
          const datarr = data_url.split('blogs');
          newURL = `/blogs${datarr[1]}`;
          window.location.href = newURL;
        }
      });
      
      const url = window.location.href;
      app._highlightSelectedBlog(url);

    },

    _getAjaxBlogData(url, newURL) {
      history.pushState({}, url, newURL);
      $.ajax({
        url: newURL,
        type: 'GET',
        beforeSend() {
          $('#loader').show();
          $('#template-blog-2 .articles_list').hide();
          $('#app_list .articles_list').hide();
          $('.pagination').hide();
        },
        success(data) {
          setTimeout(() => {
            $('#loader').hide();
            $('#template-blog-2 .articles_list').show();
            $('#app_list .articles_list').show();
            let new_data = '';
            new_data = $(data).find('#template-blog-2 .articles_list').html();
            $('.articles_list').html(new_data);
            if ($(data).find('#template-blog-2 .pagination').length > 0) {
              $('.pagination').html($(data).find('#template-blog-2 .pagination').html());
            } else {
              $('.pagination').html('');
            }
            $('.pagination').show();
          }, 900);
        },
        error(error) {
          if (error.status === 404) {
            setTimeout(() => {
              $('#loader').hide();
              $('.pagination').hide();
            }, 900);
          }
        },
      });

      app._highlightSelectedBlog(newURL);
    },

    _highlightSelectedBlog(url) {
      const tagg = url.split('tagged/');
      if (tagg.length > 1) {
        if (tagg[1].indexOf('+') !== -1) {
          const plus = tagg[1].split('+');
          $.each(plus, (indx, item) => {
            app._addClassToHighlight(item);
          });
        } else {
          app._addClassToHighlight(tagg[1]);
        }
      }
    },

    _addClassToHighlight(tag) {
      $('.categories-section li').each(function(ind, it) {
        const hre = $(this).find('a').attr('data-tag');
        if (hre === tag) {
          $(this).siblings().find('a')
            .removeClass('active');
          $(this).find('a').addClass('active');
        }
      });
    },
  },
};

export default blogMethods;

